module.exports = __webpack_public_path__ + "img/me.44aceae9.png";